/** We expect some of our newer timezones to fail in older browsers, we can ignore these errors */
export const timezoneCouldFail = (timezoneIdentifier: string) =>
  [
    'America/Ciudad_Juarez',
    'Europe/Kyiv',
    'Pacific/Kanton',
    'America/Nuuk',
    'Antarctica/McMurdo',
  ].includes(timezoneIdentifier)

const tzNormalization: Record<string, string> = {
  'America/Coral_Harbour': 'America/Atikokan',
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Godthab': 'America/Nuuk',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'Europe/Kiev': 'Europe/Kyiv',
  'Africa/Asmera': 'Africa/Asmara',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Enderbury': 'Pacific/Kanton',
}

/**
 * Some browsers return deprecated timezone even if you give them a newer timezone identifier, bring
 * it back to the newer name https://issues.chromium.org/issues/40361372
 */
export const normalizeTimezone = (timezoneIdentifier: string) =>
  tzNormalization[timezoneIdentifier] ?? timezoneIdentifier
